/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent } from "../Utility/Utility";

// const CategoryFilter = ({ categoryName, defaultData, discount }) => {
const CategoryFilter = ({ discount, checkedCategories, checkedCategoryName, categoryMap, handleCheckboxChange }) => {
  // const [checkedCategories, setCheckedCategories] = useState([]);
  // const [checkedCategoryData, setCheckedCategoryData] = useState([]);
  // const [checkedCategoryName, setCheckedCategoryName] = useState([]);

  // const categoryAllData = useSelector(
  //   (state) => state.userRoleSliceReducer.categoryData
  // );
  // const navigate = useNavigate();
  const location = useLocation();
  const translation = getTranslationData();

  // // Memoize category mapping for performance
  // const categoryMap = useMemo(() => {
  //   if (!Array.isArray(categoryAllData)) return {};
  //   return categoryAllData.reduce((acc, cat) => {
  //     acc[cat.name] = cat;
  //     return acc;
  //   }, {});
  // }, [categoryAllData]);

  // // Sync state with URL or defaultData
  // useEffect(() => {
  //   if (!categoryAllData) return;
  //   const queryParams = new URLSearchParams(location.search);
  //   const allCId = queryParams.get("categoryId");
  //   if (allCId) {
  //     const selectedCategories = decodeURIComponent(allCId).split(",");
  //     const updatedCheckedCategoryData = selectedCategories.flatMap((cId) => {
  //       const cat = categoryMap[cId];
  //       return cat ? [cat] : [];
  //     });
  //     setCheckedCategories(selectedCategories);
  //     setCheckedCategoryData(updatedCheckedCategoryData);
  //     // setPageNumber(1);
  //     if (categoryName) categoryName(updatedCheckedCategoryData, selectedCategories);
  //   } else if (defaultData && defaultData.length) {
  //     const defaultNames = defaultData.map((d) => d.name);
  //     setCheckedCategories(defaultNames);
  //     setCheckedCategoryData(defaultData);
  //     // setPageNumber(1);
  //     if (categoryName) categoryName(defaultData, defaultNames);
  //   } else {
  //     setCheckedCategories([]);
  //     setCheckedCategoryData([]);
  //     // setPageNumber(1);
  //     if (categoryName) categoryName([], []);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [categoryAllData, location.search, defaultData]);

  // const handleCheckboxChange = (event) => {
  //   const { name, checked } = event.target;
  //   let updatedCheckedCategories = checked
  //     ? [...checkedCategories, name]
  //     : checkedCategories.filter((cat) => cat !== name);
  //   // Remove duplicates
  //   updatedCheckedCategories = [...new Set(updatedCheckedCategories)];
  //   const updatedCheckedCategoryData = updatedCheckedCategories.flatMap((catName) =>
  //     categoryMap[catName] ? [categoryMap[catName]] : []
  //   );
  //   setCheckedCategories(updatedCheckedCategories);
  //   setCheckedCategoryData(updatedCheckedCategoryData);
  //   if (categoryName) categoryName(updatedCheckedCategoryData, updatedCheckedCategories);
  //   const params = new URLSearchParams(location.search);
  //   if (updatedCheckedCategories.length > 0) {
  //     params.set("categoryId", updatedCheckedCategories.join(","));
  //   } else {
  //     params.delete("categoryId");
  //   }
  //   navigate(`${location.pathname}?${params.toString()}`);
  // };
  useEffect(() => {
    trackEvent("page_browse",
      {

        page_title: location?.state?.item?.name ? location?.state?.item?.name : translation?.products,
        page_url: window.location.href,

      });
  }, []);
  // useEffect(() => {
  //   trackEvent("filter_applied", {
  //     ecommerce: {
  //       filter: {
  //         filter_type: checkedCategoryName,
  //         discount: discount,
  //       }
  //     },
  //   });
  // }, [discount]);
  return (
    <div className="sidefilboxlist category-cont">
      <span>{translation?.category}</span>
      <div
        id="categorufil2"
        className="filterinner collapse show"
        data-parent="#otherfilter"
      >
        <div className="checklistfilter">
          <div className="filktermaxht">
            {Object.keys(categoryMap).map((brand, index) => (
              <div key={index} className="brandsearch">
                <label className="checkbox-container" htmlFor={`brand-${index}`}>
                  <input
                    className="filter_category_checkbox"
                    id={`brand-${index}`}
                    type="checkbox"
                    name={brand}
                    checked={checkedCategories.includes(brand)}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor={`brand-${index}`} className="pointer" title={brand}>
                    {brand.length > 25 ? brand.substring(0, 25) + "..." : brand}
                  </label>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

CategoryFilter.propTypes = {
  categoryName: PropTypes.func,
  defaultData: PropTypes.array,
};

export default CategoryFilter;
